<template>
    <pc-input-group>
        <div class="row gx-3 align-items-end">
            <pc-label
                v-bind:label="label"
                v-bind:for-id="inputId"
                v-bind:show-required="required"
                v-bind:show-help="showHelp"
                v-bind:help-link="showHelpLinkOnly"
                class="col-12"
                v-on:help-clicked="emitHelpClicked" />
            <div class="col-12">
                <slot name="help" />
            </div>
            <pc-input-group v-bind:class="responsiveHelpers.standard">
                <pc-input
                    v-bind:id="inputId"
                    v-bind:group-id="element.DataFieldGroupId"
                    v-bind:autocomplete="BROWSER_AUTOCOMPLETE_TOKEN.givenName"
                    v-bind:validation-group-id="inputId"
                    v-bind:model-value="first"
                    v-bind:required="required"
                    v-bind:readonly="readonly"
                    v-bind:validator="validator"
                    v-bind:show-validation-errors="false"
                    v-bind:placeholder="firstNamePlaceholder"
                    v-on:update:model-value="sendDataChange(firstId, $event)"
                    v-on:validated="onValidated('first', $event)" />
            </pc-input-group>
            <pc-input-group v-bind:class="responsiveHelpers.standard">
                <pc-input
                    v-bind:validation-group-id="inputId"
                    v-bind:model-value="last"
                    v-bind:group-id="element.DataFieldGroupId"
                    v-bind:autocomplete="BROWSER_AUTOCOMPLETE_TOKEN.familyName"
                    v-bind:readonly="readonly"
                    v-bind:validator="validator"
                    v-bind:show-validation-errors="false"
                    v-bind:placeholder="lastNamePlaceholder"
                    v-on:update:model-value="sendDataChange(lastId, $event)"
                    v-on:validated="onValidated('last', $event)" />
            </pc-input-group>
            <validation-render-helper
                v-bind:validation-group-id="inputId"
                v-bind:validation-error="validationError" />
        </div>
    </pc-input-group>
</template>

<script>
    import base, { SUFFIXES, mapGroupIdsAndValues, validationRenderHelper } from "./_elementBase";
    import { BROWSER_AUTOCOMPLETE_TOKEN } from "Util/browserAutocompleteConstants";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/name.i18n";

    export default {
        components: { validationRenderHelper },
        extends: base,
        data() {
            return {
                validationResults: {
                    first: null,
                    last: null
                },
                BROWSER_AUTOCOMPLETE_TOKEN
            };
        },
        computed: {
            validationError() {
                if (this.validationResults.first && this.validationResults.first.hasError) {
                    return this.validationResults.first.error;
                }
                if (this.validationResults.last && this.validationResults.last.hasError) {
                    return this.validationResults.last.error;
                }
                return null;
            },
            ...mapGroupIdsAndValues({
                first: SUFFIXES.Name.First,
                last: SUFFIXES.Name.Last
            }),
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            onValidated(prop, validationResult) {
                this.validationResults[prop] = validationResult;
            }
        }
    };
</script>
